import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import {
  Input,
  Row,
  InputGroup,
  Col,
  Label
} from "reactstrap";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { content } from "../../../../models/content";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { confirmationActions } from "../../../../../store/actions/confirmation/confirmation.action";
import Select from 'react-select'
class UserPageSettings extends React.Component {
  state = {
    isMediaVaultOpen: false,
    value: ""
  };
  componentDidMount() {
      this.props.dispatch(confirmationActions.getByEvent(this.props.page.eventId));
  }
  handleSoftUpdate = element => {
    const { dispatch, enviroment, page } = this.props;
    if (enviroment === sourceTypes.FORM)
      dispatch(formActions.updateFormElement(element));
    if (enviroment === sourceTypes.PAGE)
    dispatch(pageActions.updatePageElement(element, null, page));
    if (enviroment === sourceTypes.TEMPLATE) {
      const template = deepClone(this.props.template);
      const newTemplate = templateHelper.handleElementUpdates(
        element,
        template
      );
      dispatch(templateActions.softUpdate(newTemplate));
    }
  };
  setAttribute = (attr, path) => {
    const { selectedElement } = this.props;
    const names = path.split(".");
    let element = deepClone(selectedElement);

    if (path === "data.style") {
      const defSettings = content.find(el => {
        return el.settings.type === element.data.type;
      });
      element.data.style = deepClone(defSettings.settings.style);
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = attr;
    } else {
      element[names[0]][names[1]] = attr;
    }
    this.handleSoftUpdate(element);
  };
  handleSlider(e, path) {
    const names = path.split(".");
    const selectedElement = deepClone(this.props.selectedElement);

    if (path === "data.style.width") {
      selectedElement[names[0]][names[1]][names[2]] = e + "%";
    } else if (path === "data.titleWidth") {
      selectedElement.data.inputWidth = 100 - e;
      selectedElement[names[0]][names[1]] = e /* + '%' */;
    } else if (path === "data.inputWidth") {
      selectedElement.data.titleWidth = 100 - e;
      selectedElement[names[0]][names[1]] = e /* + '%' */;
    }
    this.handleSoftUpdate(selectedElement);
  }
  addressOnChange = e => {
    this.setState({ value: e.target.value });
  };
  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray
    });
  };
  handleChange(e, path, val) {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = null;

    if (val && val.hex !== undefined) {
      const { r, g, b, a } = val.rgb;
      value = `rgba(${r},${g},${b},${a})`;
    } else if (e.target === undefined) value = e;
    else if (val) value = val;
    else value = e.target.value;

    if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.handleSoftUpdate(element);
  }
  handleSelectOnChange = (selectedOption, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    if (names.length === 2) {
      element[names[0]][names[1]] = selectedOption.value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = selectedOption.value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = selectedOption.value;
    }
    this.handleSoftUpdate(element);
  }
  toggleMediaVault = () => {
    this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
  };
  render() {
    const { selectedElement, confirmation } = this.props;
    let confirmationOptions = confirmation && confirmation.confirmationList ?  confirmation.confirmationList.map(cl=> {
        return {label:cl.name, value:cl.confirmationId};
    }) : [];
    return (
      <div>
        <ListExpansion
          footer={false}
          icon="fa fa-image"
          description="UserPageSettings"
        >
          <br />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="Height" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <InputGroup className="mb-3">
                <Input
                  onChange={e => this.handleChange(e, "data.style.height")}
                  type="number"
                  value={parseInt(selectedElement.data.style.height)}
                />
              </InputGroup>
            </Col>
          </Row>
          
            <Row>
              <Col className="list-setting-item-title">
                <Label>
                  <SystemLabel name="Confirmation" />
                </Label>
              </Col>
              <Col className="list-setting-item-input">
                <Select
                   options={confirmationOptions}
                  value={confirmationOptions.find(t => {
                    return t.value === selectedElement.data.confirmationId;
                  })}
                  onChange={selectedOption =>
                    this.handleSelectOnChange(
                      selectedOption,
                      "data.confirmationId"
                    )
                  }
                />
              </Col>
            </Row>
          
        </ListExpansion>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let selectedElement = null;
  if (enviroment === sourceTypes.FORM)
    selectedElement = state.form.selectedElement;
  if (enviroment === sourceTypes.PAGE)
    selectedElement = state.page.selectedElement;
  if (enviroment === sourceTypes.TEMPLATE)
    selectedElement = state.template.selectedElement;
  return {
    enviroment: enviroment,
    template: state.template.template,
    form: state.form,
    page: state.page,
    confirmation:state.confirmation,
    selectedElement: selectedElement
  };
}
export default connect(mapStateToProps)(UserPageSettings);
